import { IPagination } from '@app/interfaces/pagination';
import { api } from './http.api';
import { IGetInventoriesBody, IInventoryType } from '@app/interfaces/inventory';
import { IPopulatedWaterbody } from '@app/interfaces/waterbody';
import { IUser } from '@app/interfaces/user';
import dayjs from 'dayjs';
import { filterDateFormat } from '@app/constants/dateFormats';
import { InventoryFilterState } from '@app/store/slices/inventoryFilters';
import { formatFromFilter } from '@app/utils/formatDate';

const inventoryPathBase = '/web/admin/inventory';

export const getInventoryEntrypointData = async () => {
  try {
    const { data } = await api.get(`${inventoryPathBase}/entrypoint`);

    return { error: false, data };
  } catch (error) {
    return { error: true, data: undefined };
  }
};

export const getInventories = async (
  pagination: IPagination,
  fetchParams: Partial<InventoryFilterState>,
  sortBy?: string,
  sortOrder?: 'ASC' | 'DESC',
) => {
  try {
    let paramsSubString = `page=${pagination.current}&pageSize=${pagination.pageSize}&softDeleted=false`;

    if (sortBy) {
      paramsSubString += `&sortBy=${sortBy}`;
    }

    if (sortOrder) {
      paramsSubString += `&sortOrder=${sortOrder}`;
    }

    const body = {} as IGetInventoriesBody;
    const {
      selectedWaterbodyIds,
      selectedEmployeeIds,
      selectedTypeIds,
      fromPlannedFilter,
      toPlannedFilter,
      fromExecutedFilter,
      toExecutedFilter,
      onlyPlanned,
      onlyExecuted,
    } = fetchParams;

    if (selectedWaterbodyIds?.length) {
      body.waterbody = selectedWaterbodyIds;
    }

    if (selectedEmployeeIds?.length) {
      body.employees = selectedEmployeeIds;
    }

    if (selectedTypeIds?.length) {
      body.type = selectedTypeIds;
    }

    if (fromPlannedFilter) {
      console.log(fromPlannedFilter);
      const fromPlannedFilterString = fromPlannedFilter ? formatFromFilter(fromPlannedFilter) : '';
      console.log(fromPlannedFilterString);
      body.plannedStart = fromPlannedFilterString;
    }

    if (toPlannedFilter) {
      const toPlannedFilterString = toPlannedFilter ? formatFromFilter(toPlannedFilter) : '';

      body.plannedEnd = toPlannedFilterString;
    }

    if (fromExecutedFilter) {
      const fromExecutedFilterString = fromExecutedFilter ? formatFromFilter(fromExecutedFilter) : '';

      body.start = fromExecutedFilterString;
    }

    if (toExecutedFilter) {
      const toExecutedFilterString = toExecutedFilter ? formatFromFilter(toExecutedFilter) : '';

      body.end = toExecutedFilterString;
    }

    if (onlyPlanned !== null) {
      body.onlyPlanned = onlyPlanned;
    }

    if (onlyExecuted !== null) {
      body.onlyExecuted = onlyExecuted;
    }
    const response = await api.post(`${inventoryPathBase}/filter?${paramsSubString}`, body);

    return {
      error: false,
      data: {
        ...response.data,
        pagination: {
          ...response.data.pagination,
          current: response.data.pagination.currentPage,
          total: response.data.pagination.totalItems,
        },
      },
    };
  } catch (error) {
    return { error: true, data: undefined };
  }
};

const pick = <T>(obj: T, keys: (keyof T)[]) => {
  return keys.reduce((acc, key) => {
    if (obj[key]) {
      acc[key] = obj[key];
    }

    return acc;
  }, {} as Partial<T>);
};

export const planNewInventory = async (payload: {
  start: string;
  waterbody: IPopulatedWaterbody;
  employee: IUser;
  type: IInventoryType;
}) => {
  try {
    const { data } = await api.post(`${inventoryPathBase}/plan`, {
      plannedStart: payload.start,
      waterbody: pick(payload.waterbody, ['id']),
      employee: pick(payload.employee, ['id']),
      type: pick(payload.type, ['id']),
    });

    return { error: false, data };
  } catch (error) {
    return { error: true, data: undefined };
  }
};

export const editInventory = async (
  id: number,
  payload: { start: string; waterbody: IPopulatedWaterbody; employee: IUser; type: IInventoryType },
) => {
  try {
    const { data } = await api.patch(`${inventoryPathBase}/plan/${id}`, {
      plannedStart: payload.start,
      waterbody: pick(payload.waterbody, ['id']),
      employee: pick(payload.employee, ['id']),
      type: pick(payload.type, ['id']),
      updatedAt: dayjs.utc().format(filterDateFormat),
    });

    return { error: false, data };
  } catch (error) {
    return { error: true, data: undefined };
  }
};
